export default __webpack_public_path__ + "static/media/computerLady3M.c24835da.jpg";